import React, { useState } from "react";

import validator from "validator";

import { Oval } from "react-loader-spinner";

import { useNavigate } from "react-router-dom";

import "tachyons";

import "./footer.css"

export default function Footer({

}) {
  const navigate = useNavigate();
  //states
  const [email, setEmail] = useState("");

  const [emailError, setEmailError] = useState("");
  const [flag, setFlag] = useState(null);
  const [foundErr, setFoundErr] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const [status, setStatus] = useState("idle"); 
  // idle | loading | success | error
  const [message, setMessage] = useState("");

  const handleSubscribe = async () => {
    if (!validator.isEmail(email)) {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    setMessage("");

    try {
      const res = await fetch("https://api.terraweb.africa/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setStatus("error");
        setMessage(data.message || "Failed to subscribe.");
        return;
      }

      setStatus("success");
      setMessage("You’re subscribed! Check your email for confirmation.");
      setEmail("");

    } catch (e) {
      setStatus("error");
      setMessage("Server error. Please try again later.");
    }
  };

  const validateEmail = () => {
    var emailnew = email;

    if (validator.isEmail(emailnew)) {
      setEmailError("valid");
      setFlag(1);
    } else {
      setEmailError("not valid");
      setFlag(2);
    }
  };
  function onEmailChange(event) {
    if (email.length >= 1) {
      setFlag(1);
    } else {
      setFlag(2);
    }
    setEmail(event.target.value);
  }
  return (
   

    <footer className="footer-section">
      <div className="footer-content">
        {/* Logo */}
        <div className="footer-block">
          <img
            src="/img/LOGO-FAVCON.png"
            alt="Terraweb logo"
            className="footer-logo"
          />
        </div>
              {/* ===== FOOTER ===== */}
      <div className="footer">
        <div className="footer__grid">
          <div className="footer__brand">
            <h1 className="footer__logo">TerraWeb</h1>
            <p className="footer__tagline">
              Join us in building a future where data connects, communication
              empowers, and technology creates lasting impact.
            </p>
          </div>

          <div className="footer__contact">
            <p>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3 6h18v12H3V6Zm0 0 9 7 9-7"
                  stroke="currentColor"
                  strokeWidth="1.7"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              info@terraweb.africa
            </p>
            <p>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.5 2.1L8 9.7a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.7 2Z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              +254 740 40 14 92
            </p>
            <p>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 22s7-6.4 7-12a7 7 0 1 0-14 0c0 5.6 7 12 7 12Z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.6" />
              </svg>
              Nairobi, Kenya
            </p>
          </div>

          <div className="footer__social">
            <p>Follow Us</p>
            <div className="footer__social-icons">
              <a href="https://facebook/com" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 9h3V6h-3a4 4 0 0 0-4 4v2H7v3h3v6h3v-6h3l1-3h-4v-2c0-.6.4-1 1-1Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a href="https://linkedin.com" aria-label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3V9Zm7 0h3.8v1.64h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.7c0-1.36-.02-3.1-1.89-3.1-1.9 0-2.19 1.48-2.19 3v5.8h-4V9Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a href="https://x.com" aria-label="X">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M22 5.9c-.7.3-1.5.6-2.3.7a4 4 0 0 0 1.8-2.2 8 8 0 0 1-2.5 1 4 4 0 0 0-6.9 3.6A11.4 11.4 0 0 1 3.8 4.6a4 4 0 0 0 1.2 5.3c-.6 0-1.2-.2-1.7-.5v.1a4 4 0 0 0 3.2 3.9c-.6.1-1.2.2-1.8.1a4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 17.9a11.3 11.3 0 0 0 6.1 1.8c7.4 0 11.4-6.1 11.4-11.4v-.5c.8-.6 1.4-1.3 2-2.1Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a href="https://youtube.com" aria-label="YouTube">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.6 7.2a2.7 2.7 0 0 0-1.9-1.9C18 5 12 5 12 5s-6 0-7.7.3A2.7 2.7 0 0 0 2.4 7.2 28 28 0 0 0 2 12a28 28 0 0 0 .4 4.8 2.7 2.7 0 0 0 1.9 1.9C6 19 12 19 12 19s6 0 7.7-.3a2.7 2.7 0 0 0 1.9-1.9A28 28 0 0 0 22 12a28 28 0 0 0-.4-4.8ZM10 15V9l5.2 3-5.2 3Z"
                    fill="currentColor"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

        {/* Newsletter */}
     <div className="newsletter ">
      <p>Subscribe to our Newsletter. Your email is safe with us.</p>
      <input
        type="email"
        className={`newsletter-input ${status === "error" ? "error" : ""}`}
        placeholder="Enter your email"
        value={email}
        onChange={(e) => {
          setEmail(e.target.value);
          setStatus("idle");
        }}
      />

      <button
        className="newsletter-button"
        onClick={handleSubscribe}
        disabled={status === "loading"}
      >
        {status === "loading" ? (
          <span className="loader"></span>
        ) : (
          "Subscribe"
        )}
      </button>

      {status === "error" && (
        <p className="footer-error animate-fade">{message}</p>
      )}

      {status === "success" && (
        <p className="footer-success animate-fade">{message}</p>
      )}
    </div>

        {/* Social */}
        {/* <div className="footer-block">
          <h4 className="footer-heading">Get in Touch</h4>
          <button
            className="social-button"
            onClick={() => window.open("https://facebook.com/", "_blank")}
          >
            <svg
              className="social-icon"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M15.117 0H.883C.395 0 0 .395 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.39h2.086V5.607c0-2.066 1.262-3.19 3.106-3.19.883 0 1.642.064 1.863.094v2.16h-1.28c-1 0-1.195.476-1.195 1.176v1.54h2.39l-.31 2.416h-2.08V16h4.077c.488 0 .883-.395.883-.883V.883C16 .395 15.605 0 15.117 0" />
            </svg>
            <span className="ml2">Facebook</span>
          </button>
        </div> */}
      </div>
      <div className="footer-divider" />


      {/* Terms and copyright */}

      <div className="footer-bottom">
        <span
          className="footer-link"
          onClick={() => navigate("/termsofservice")}
        >
          Terms of Service
        </span>
        <p className="footer-copy">&copy; 2026 Terrawebgroup. All rights reserved.</p>
      </div>
    </footer>
  );
}

// export default Footer;
